module.exports = __webpack_public_path__ + "static/media/cosplay3.c0ff8c9f.jpg";